import PropTypes from 'prop-types';

const propType = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string,
  duration: PropTypes.number,
  startDate: PropTypes.number,
};

export default { propType };
